

<div class="label">
    <slot />
</div>


<style>
    .label {
        opacity: 0.5;
    }
</style>